import { ChangeDetectorRef, Component, computed, inject, OnInit, output } from '@angular/core';
import { SignupV2Service } from '../../signup-v2.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OnlyNumberDirective } from '../../../../shared/directives/only-number.directive';

@Component({
  selector: 'app-personal-info-step',
  imports: [CommonModule, ReactiveFormsModule, MatCheckboxModule, MatSlideToggleModule, OnlyNumberDirective],
  templateUrl: './personal-info-step.component.html',
  styleUrl: './personal-info-step.component.scss'
})
export class PersonalInfoStepComponent implements OnInit {

  svc = inject(SignupV2Service);
  public cdRef = inject(ChangeDetectorRef);

  // Output para comunicarse con el componente padre
  stepCompleted = output<void>();

  howHeardSources = computed(() => this.svc.getHowHeardSource());
  deliveryDayText = computed(() => this.svc.getDeliveryDayText());
  driversPlaceHolders = computed(() => this.svc.getDriversPlaceholder());

  constructor() { }

  ngOnInit(): void {
    this.svc.loadHeardSourcesIfNeeded();
  }

  invalid(name: string) { const c = this.svc.personalForm.get(name); return !!c && c.invalid && (c.dirty || c.touched); }
  valid(name: string) { const c = this.svc.personalForm.get(name); return !!c && c.valid && (c.dirty || c.touched); }
  touched(name: string) { const c = this.svc.personalForm.get(name); return !!c && (c.dirty || c.touched); }

  showPwd = false;
  showPwd2 = false;

  // Drag-to-scroll properties
  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;
  private driverCardsElement: HTMLElement | null = null;

  togglePwd(which: 'main' | 'confirm') {
    if (which === 'main') this.showPwd = !this.showPwd;
    else this.showPwd2 = !this.showPwd2;
  }

  howHeardSourceRequiresDetails(): boolean {
    const selected = this.svc.personalForm.get('howHeardSource')?.value;
    if (selected === null || selected === undefined || selected === '') return false;
    const refs = this.svc.getHowHeardSource();
    const ref = refs.find(r => r.id === selected);
    return !!ref?.hasAdditionalInfo;
  }

  async onNext() {
    if (!this.svc.canProceed('personal')) return;
    const isCompleted = await this.svc.markCompleted('personal');
    if (isCompleted) {
      this.stepCompleted.emit();
    }
  }

  // Drag-to-scroll methods
  onMouseDown(event: MouseEvent) {
    this.driverCardsElement = event.currentTarget as HTMLElement;
    this.isDragging = true;
    this.startX = event.pageX - this.driverCardsElement.offsetLeft;
    this.scrollLeft = this.driverCardsElement.scrollLeft;
    // this.driverCardsElement.style.cursor = 'grabbing';
    event.preventDefault();
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging || !this.driverCardsElement) return;
    event.preventDefault();
    const x = event.pageX - this.driverCardsElement.offsetLeft;
    const walk = (x - this.startX) * 2; // Multiply by 2 for faster scrolling
    this.driverCardsElement.scrollLeft = this.scrollLeft - walk;
  }

  onMouseUp(event: MouseEvent) {
    if (!this.isDragging || !this.driverCardsElement) return;
    this.isDragging = false;
    // this.driverCardsElement.style.cursor = 'grab';
  }

  // Touch events for mobile devices
  onTouchStart(event: TouchEvent) {
    this.driverCardsElement = event.currentTarget as HTMLElement;
    this.isDragging = true;
    this.startX = event.touches[0].pageX - this.driverCardsElement.offsetLeft;
    this.scrollLeft = this.driverCardsElement.scrollLeft;
  }

  onTouchMove(event: TouchEvent) {
    if (!this.isDragging || !this.driverCardsElement) return;
    event.preventDefault();
    const x = event.touches[0].pageX - this.driverCardsElement.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.driverCardsElement.scrollLeft = this.scrollLeft - walk;
  }

  onTouchEnd(event: TouchEvent) {
    if (!this.isDragging || !this.driverCardsElement) return;
    this.isDragging = false;
  }
}
